import { Component, Input, forwardRef } from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-star-rating',
    standalone: true,
    template: `
        <div class="star-rating" [class.disabled]="disabled">
            <span
                *ngFor="let star of stars; let i = index"
                (click)="!disabled && setRating(i + 1)"
                (mouseover)="!disabled && hoverRating(i + 1)"
                (mouseleave)="!disabled && hoverRating(0)"
                [ngClass]="{ filled: (hoveredRating || rating) > i }"
            >
                ★
            </span>
        </div>
        <p class="body-2 mb-6 ml-1 text-base font-semibold">
            Hai votato <span class="body-2">{{ rating || 0 }}</span> /
            <span class="body-2">{{ starsCount }}</span>
        </p>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StarRatingComponent),
            multi: true,
        },
    ],
    imports: [CommonModule, ReactiveFormsModule],
})
export class StarRatingComponent implements ControlValueAccessor {
    @Input() starsCount = 5;
    @Input() disabled = false; // Nuovo input per disabilitare il rating

    stars: number[] = [];
    rating = 0;
    hoveredRating = 0;

    onChange = (rating: number) => {};
    onTouched = () => {};

    constructor() {
        this.stars = Array(this.starsCount).fill(0);
    }

    writeValue(value: number): void {
        this.rating = value || 0;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    setRating(value: number): void {

        console.log(this.disabled)
        if (!this.disabled) {
            this.rating = value;
            this.onChange(value);
            this.onTouched();
        }
    }

    hoverRating(value: number): void {
        if (!this.disabled) {
            this.hoveredRating = value;
        }
    }
}
